import { resolveStaffModuleAccess } from './staffModulePermissions';

/**
 * Grant de procesamiento manual de nóminas — sincronizar con smart_back y server_admin.
 *
 * Default-DENY para roles externos (USER_SMARTCFO); default-ALLOW para el equipo
 * interno (ADMIN/COLABORADOR/SUPER_COLABORADOR). Se resuelve SOLO a nivel usuario
 * (igual que smart_back), no a nivel empresa: el permiso se concede al usuario.
 */
export const PROCESAR_NOMINA_MANUAL_MODULE_ID = 'procesar_nomina_manual';

export function resolveProcesarNominaManualAccess(userModulePermissions, roles) {
  return resolveStaffModuleAccess(
    PROCESAR_NOMINA_MANUAL_MODULE_ID,
    userModulePermissions,
    undefined,
    undefined,
    roles,
  );
}
